import { createEvent } from 'effector';

export const TN_SMS_DISCOUNT_CODE = 'TN15OFF';

export const setPromoShortCode = createEvent<string>();
export const setHasSeenDiscountSheet = createEvent<boolean>();
export const setFromSms = createEvent<boolean>();
